import { Container } from "./styles";
import emailIcon from "../../assets/email-icon.svg";
import phoneIcon from "../../assets/phone-icon.svg"
import { Form } from "../Form/Form";


export function Contact(){

  return(
    <Container id="contact">
      <header>
        <h2>contact me</h2>
        <p>If you want to collaborate on a project or want to talk to me, don't hesitate to text me.</p>
      </header>
      <div className="contacts">
        <div>
          <img src={emailIcon} alt="Email" />
          <a href="mailto:sabadmodi@gmail.com">sabadmodi@gmail.com</a>
        </div>
        <div>
          <img src={phoneIcon} alt="Email" />
          <a href="tel:+971585465942">+971 58 546 5942</a>
        </div>  
      </div>
      <Form></Form>
    </Container>
  )
}